module.exports = __webpack_public_path__ + "assets/img/lakshay.e667f092.jpg";